import React from "react";
import { useTranslation } from "react-i18next";

const FillAllRequiredFieldsCaption = () => {
  const { t } = useTranslation();
  return (
    <p className="text-field-error-dark font-bold text-sm">{t('fill_all_required_fields')}</p>
  );
}
export default FillAllRequiredFieldsCaption;